/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */

// THIS CODE IS GENERATED - DO NOT MODIFY.
const u = undefined;

function plural(val: number): number {
const n = val;

if (n === 1)
    return 1;
return 5;
}

export default ["eu",[["g","a"],["AM","PM"]],[["AM","PM"]],[["I","A","A","A","O","O","L"],["ig.","al.","ar.","az.","og.","or.","lr."],["igandea","astelehena","asteartea","asteazkena","osteguna","ostirala","larunbata"],["ig.","al.","ar.","az.","og.","or.","lr."]],u,[["U","O","M","A","M","E","U","A","I","U","A","A"],["urt.","ots.","mar.","api.","mai.","eka.","uzt.","abu.","ira.","urr.","aza.","abe."],["urtarrila","otsaila","martxoa","apirila","maiatza","ekaina","uztaila","abuztua","iraila","urria","azaroa","abendua"]],u,[["a","o"],["K.a.","K.o."],["Kristo aurretik","Kristo ondoren"]],1,[6,0],["yy/M/d","y('e')'ko' MMM d('a')","y('e')'ko' MMMM'ren' d('a')","y('e')'ko' MMMM'ren' d('a'), EEEE"],["HH:mm","HH:mm:ss","HH:mm:ss (z)","HH:mm:ss (zzzz)"],["{1} ({0})",u,u,u],[",",".",";","%","+","â","E","Ã","â°","â","NaN",":"],["#,##0.###","%Â #,##0","#,##0.00Â Â¤","#E0"],"EUR","â¬","euroa",{"BYN":[u,"Ñ."],"ESP":["â§"],"JPY":["JPÂ¥","Â¥"],"PHP":[u,"â±"],"THB":["à¸¿"],"TWD":["NT$"],"USD":["US$","$"]},"ltr", plural];
